import { FC, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/creditCard/creditCardPage/CardStatus/CardStatus.styl'
import { CCStatus } from 'components/features/creditCard/creditCardStore/types'
import { Arc } from 'components/atoms/Arc/Arc'
import { IconCircled } from 'components/features/pfm/IconCircled/IconCircled'

type CardStatusProps = {
  status?: CCStatus
  text?: string
  iconSlug?: string
  isLoading?: boolean
  onClick?: () => void
  hoverProps?: React.HTMLAttributes<HTMLElement>
}
export const CardStatus: FC<CardStatusProps> = (props) => {
  const { text, status, iconSlug, isLoading, onClick, hoverProps } = props
  const iconChild = useMemo(() => {
    if (status === 'processing' || isLoading) {
      return (
        <div className={ styles.spinner }>
          <Arc ratio={ 0.9 } />
        </div>
      )
    }

    if (!!iconSlug) {
      return <IconCircled iconSlug={ iconSlug } theme='cyan' />
    }

    return null
  }, [iconSlug, status, isLoading])

  const textChild = useMemo(() => !!text && (
    <span className={ styles.cardText }>{ text }</span>
  ), [text])

  const contentChild = useMemo(() => (
    <div className={ cn(styles.cardHolder, { [styles.withText]: !!textChild }) } { ...hoverProps }>
      { !!iconChild && (
        <div className={ styles.iconHolder }>
          <div className={ styles.iconWrapper }>
            <div className={ styles.icon }>
              { iconChild }
            </div>
          </div>
        </div>
      ) }
      { textChild }
    </div>
  ), [hoverProps, iconChild, textChild])

  const clickableContentChild = useMemo(() => !!onClick && !!contentChild && (
    <button onClick={ onClick } className={ styles.clickableContent } { ...hoverProps }>
      { contentChild }
    </button>
  ), [onClick, contentChild, hoverProps])

  return clickableContentChild || contentChild
}
